import { cn } from '../lib/cn';

export interface QuickReplyOption {
  label: string;
  value: string;
}

interface QuickRepliesProps {
  options: QuickReplyOption[];
  style: 'chips' | 'list';
  brandingColor: string;
  onSelect: (value: string) => void;
}

export function QuickReplies({
  options,
  style,
  brandingColor,
  onSelect,
}: QuickRepliesProps) {
  if (!options.length) return null;

  if (style === 'list') {
    return (
      <div class="flex flex-col gap-[6px] px-3 mb-[10px] max-w-[76%]">
        {options.map((opt, i) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onSelect(opt.value)}
            style={
              {
                animationDelay: `${120 + 70 * i}ms`,
                '--mirlo-brand': brandingColor,
              } as Record<string, string>
            }
            class={cn(
              'animate-chip-in',
              'w-full rounded-[13px] px-4 py-[9.5px]',
              'bg-w-bb-bg text-[var(--brand)] text-center',
              'text-[13.5px] font-semibold',
              'border-0 cursor-pointer',
              'hover:opacity-80 active:scale-[0.98] transition-all duration-150',
            )}
          >
            {opt.label}
          </button>
        ))}
      </div>
    );
  }

  // chips (default)
  return (
    <div class="flex flex-wrap gap-[8px] px-3 mb-[10px]">
      {options.map((opt, i) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onSelect(opt.value)}
          style={{
            animationDelay: `${120 + 70 * i}ms`,
            borderColor: `color-mix(in srgb, ${brandingColor} 55%, white)`,
            color: brandingColor,
          }}
          class={cn(
            'animate-chip-in',
            'rounded-full px-[15px] py-[9.5px]',
            'bg-w-bb-bg',
            'text-[13.5px] font-semibold',
            'border-[1.5px] cursor-pointer',
            'hover:opacity-80 active:scale-[0.98] transition-all duration-150',
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
